Vue.filter('formatRingnumber', function (value, landcode) {
    return `${landcode} ${value}`;
});
